import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from '@gsap/react';
import customTransition from '../utils/transition';
import Header from '../components/Header';
import { Link, useLocation } from 'react-router-dom';
import Markdown from 'react-markdown';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

function CasePage({
    meta,
}) {
    const [markdownContent, setMarkdownContent] = React.useState(null);
    const location = useLocation();
    console.log(meta)
    useEffect(() => {
        fetch(`/content/${location.pathname}.md`)
            .then((res) => res.text()) // Parse the response as text
            .then((text) => setMarkdownContent(text)) // Store the text in state
            .catch((err) => console.error(err));
    }, [location.pathname]);

    return (
        <div>
            <Header
                main={
                    <>
                        <div>{meta?.title}</div>
                    </>
                }
            />
            <main>
                <section id="about" data-color="white black">
                    <div className="container">
                        {/* <img src={banner} alt="startup weekend" style={{ width: '100%' }} /> */}
                        <div className="split-row px-xl">
                            <div>
                                {
                                    meta?.image && (
                                        <img src={meta?.image} alt={meta?.title} style={{ width: '100%', borderRadius: 10 }} />
                                    )
                                }
                            </div>
                            <div>
                                <div className="split-content">
                                    <p>
                                        {meta?.description}
                                    </p>
                                    <br />
                                    {
                                        meta?.website && (
                                            <a href={meta.website} target="_blank" className="btn">
                                                visit website
                                            </a>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        {
                            meta?.video && (
                                <>
                                    <div className='videoWrapper'>
                                        <iframe width="100%" height="783" src={meta.video} title={meta.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{ borderRadius: 10 }} allowFullScreen data-lenis-prevent></iframe>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </section>
                <section id="content" data-color="white black">
                    <div className="container narrow">
                        {markdownContent && <Markdown>{markdownContent}</Markdown>}

                        <div className="pt-xl">
                            <h2>
                                Ready to{" "}
                                <span className="bg-rounded bg-blue">Spark Innovation?</span>
                            </h2>
                            <div className="split-content">
                                <p>
                                    Contact Hackonnect today to discuss your IT event needs.
                                    Let's collaborate on creating a successful and impactful
                                    program that propels innovation forward.
                                </p>
                                <br />
                                <Link to="/contact" className="btn">
                                    start a project
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default customTransition(CasePage);